/* eslint-disable @next/next/no-img-element */
import { ReactNode, useState } from 'react';
import styles from './EnterLayout.module.css';
import EnterProgressBar from 'components/enter/ProgressBar';
import AboutUsModule from 'components/about-us/AboutUsModule';
import GenericModal from 'components/GenericModal';
import RoundedButton from 'components/RoundedButton';
import { convertNewLinesToBr } from 'utils/rendering/render';
import { runningInProduction } from 'utils/constants';

interface Props {
  children: ReactNode;
  sidePanel: ReactNode;
  sidePanelBackground: 'TEAL' | 'GREY';
  stepName: string;
  stepIcon: ReactNode;
  stepIntroText?: ReactNode;
  stepTooltipContent?: ReactNode;
  /** The 1-based step index. This component was written whilst we had an ongoing AB test for "boost". See
   * EnterProgressBar's code for more details */
  stepIndex: number;
}
const EnterLayout = (props: Props) => {
  const [tooltipExpanded, setTooltipExpanded] = useState(false);
  return (
    <div className="aboutUsTypographyReset">
      <AboutUsModule background="white" withNoPadding>
        {/* Uncomment these elements to debug the layout
          <AboutUsSiteContainer>
            <div style={{ background: 'red' }}>
              This container will be the max width of the site, which should align with the main and side containers
            </div>
          </AboutUsSiteContainer> */}
        <div className={styles.columns}>
          <div className={styles.main}>
            <div className={styles.mainInner}>
              <EnterProgressBar progressBars={props.stepIndex} noBottomMargin />
              <div className={styles.stepIconArea}>
                <div className={styles.stepIcon}>{props.stepIcon}</div>
                {props.stepTooltipContent && (
                  <button
                    className={styles.infoButton}
                    aria-label="Open step information"
                    onClick={() => setTooltipExpanded(true)}
                    type="button"
                  >
                    <img
                      src="https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/enter/CircleQuestionMark.png"
                      width="20"
                      height="20"
                      alt=""
                    />
                  </button>
                )}
                <h1
                  data-text={props.stepName}
                  className={
                    styles.stepName + ' aboutUsTypographyHeaderXlargeOnWhite'
                  }
                >
                  {props.stepName}
                </h1>
              </div>
              {props.stepIntroText && (
                <div
                  className={
                    'aboutUsTypographyCentered ' + styles.stepIntroText
                  }
                >
                  {typeof props.stepIntroText === 'string'
                    ? convertNewLinesToBr(props.stepIntroText)
                    : props.stepIntroText}
                </div>
              )}
              {props.children}
            </div>
          </div>
          <div
            className={
              styles.sidePanel +
              ' ' +
              styles['sidePanelBackground_' + props.sidePanelBackground]
            }
          >
            <div className={styles.sidePanelInner}>{props.sidePanel}</div>
          </div>
        </div>
        {tooltipExpanded && (
          <GenericModal>
            <div className={styles.tooltipStepIcon}>{props.stepIcon}</div>
            <h2 className="aboutUsTypographyHeaderMedium">{props.stepName}</h2>
            <div className={styles.tooltipContent}>
              {props.stepTooltipContent}
            </div>
            <RoundedButton
              rebrandDm2025
              onClick={() => setTooltipExpanded(false)}
            >
              Got it
            </RoundedButton>
          </GenericModal>
        )}
      </AboutUsModule>
    </div>
  );
};

export default EnterLayout;
